import { useState, useEffect, useRef, useContext, createContext } from "react";

export const TimerContext = createContext();

export const useTimer = () => useContext(TimerContext);

export const TimerProvider = ({ children }) => {
  const START_SECONDS = 600; // 10 minutes
  const [isOneMinuteLeft, setIsOneMinuteLeft] = useState(false);

  const [formattedTime, setFormattedTime] = useState("10:00");
  const secondsRef = useRef(START_SECONDS);
  const intervalRef = useRef(null);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const startTimer = () => {
    if (intervalRef.current) return; // prevent multiple intervals

    intervalRef.current = setInterval(() => {
      if (secondsRef.current <= 0) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        return;
      }

      secondsRef.current -= 1;
      setFormattedTime(formatTime(secondsRef.current));

      if (secondsRef.current === 60) {
        setIsOneMinuteLeft(true);
      }

    }, 1000);
  };

  const resetTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = null;
    secondsRef.current = START_SECONDS;
    setFormattedTime("10:00");
    setIsOneMinuteLeft(false);
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  return (
    <TimerContext.Provider
      value={{
        startTimer,
        resetTimer,
        formattedTime,
        isOneMinuteLeft,
        setIsOneMinuteLeft
      }}
    >
      {children}
    </TimerContext.Provider>
  );
};
export default useTimer;
